import axios from "axios";
import {
    loginSuccess,
    loginFail,
    getUserSuccess,
    changePasswordSuccess,
    changePasswordFailed,
    changePasswordStateClearSuccess,
    myProfileUpdatedSuccess,
    userDataUpdated,
    myProfileUpdatedFail,
    paymentDataByAccountIDSuccess,
    paymentDataByAccountIDFail,
    getUserByAccountIDFail,
    getUserByAccountIDSuccess,
    switchAccountByID,
    switchBackAccount,
    clearStates
} from '../constant';
import { setAuthToken } from '../../tokenHandler';
import { Api } from '../../Config/config.js';
import { store } from "../store";



// axios.defaults.withCredentials = true;

export const loginAction = async (dispatch, body) => {
    try {
        const response = await axios.post(`${Api}auth/login`, body);
        if (!!response.data) {
            const token = response.data.tokens.access.token;
            await setAuthToken(token, response.data.user);
            dispatch({
                type: loginSuccess,
                payload: response.data,
            });
            return {success : "success" };
        } else {
            dispatch({
                type: loginFail,
                payload: { message: "Something went wrong. Contact Support" },
            });
        }
    } catch (error) {
        dispatch({
            type: loginFail,
            payload: error.response.data,
        });

        return { success: false };
    }
};

export const changeUserPassword = async (dispatch, body) => {
    try {
        const response = await axios.patch(`${Api}auth/change-password`, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + store.getState().authReducer.tokens.access.token
            },
        });

        if (!!response.data) {
            dispatch({
                type: changePasswordSuccess,
                payload: response.data,
            });
        }
    } catch (error) {
        dispatch({
            type: changePasswordFailed,
            payload: error.response.data,
        });
    }
};

export const changeUserPasswordStateClear = async (dispatch) => {
    dispatch({
        type: changePasswordStateClearSuccess,
        payload: null,
    });

};

export const getPaymentDataByAccountID = async (dispatch, accountId) => {
    try {
        const response = await axios.get(`${Api}payments/account/${accountId}`);
        dispatch({
            type: paymentDataByAccountIDSuccess,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: paymentDataByAccountIDFail,
            payload: error.response.data,
        });
    }
};

export const getUserByAccountID = async (dispatch, accountID,signal) => {
    try {
        const response = await axios.get(`${Api}/users/search?accountID=${accountID}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + store.getState().authReducer.tokens.access.token
            },
            signal: signal 
        });
        dispatch({
            type: getUserByAccountIDSuccess,
            payload: response.data,
        });
    } catch (error) {
        if (axios.isCancel(error)) {
            console.log('Request canceled:', error.message);
          } else {
        dispatch({
            type: getUserByAccountIDFail,
            payload: error.response.data,
        });
    }
    }
};


export const switchAccount = async (dispatch, newAccountData) => {
    try {
        const state = store.getState();
        if (!state.authReducer.isSwitched) {
            dispatch({
                type: switchAccountByID,
                payload: newAccountData
            });
            return {response : "success" };
        }
    } catch (error) {
        console.log(error);
    }
};


export const switchBackToOriginalAccount = (dispatch) => {
    try {
        const state = store.getState();
        if (state?.authReducer?.originalData && state?.authReducer?.originalTokens) {
            dispatch({
                type: switchBackAccount
            });
            return {response : "success" };
        }
    } catch (error) {
        console.log(error);
    }
}

export const clearStatesAction = (dispatch) => {
    dispatch({ type: clearStates });
};

